export default __webpack_public_path__ + "static/media/Edit.79d3beab.svg";